import gql from 'graphql-tag';

export default gql`
  query SearchArtists(
    $query: String
    $profession: String
    $specialty: String
    $country: String
  ) {
    searchArtists(
      query: $query
      profession: $profession
      specialty: $specialty
      country: $country
    ) {
      artists {
        id
        slug
        name
        lastname
        biography
        profession
        nationality
        residence
        specialty
        images {
          url
        }
        createdAt
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/SearchArtists.js